const REQUIRED_MEMBER_FIELDS = [
  { key: 'name', label: 'Name' },
  { key: 'address', label: 'Address' },
  { key: 'age', label: 'Age' },
  { key: 'occupation', label: 'Occupation' },
  { key: 'mobile', label: 'Mobile' },
  { key: 'startdate', label: 'Start Date' },
  { key: 'duedate', label: 'Due Date' }
];

function parseInteger(value) {
  const parsedValue = Number.parseInt(String(value ?? '').trim(), 10);
  return Number.isFinite(parsedValue) ? parsedValue : null;
}

function parseDecimal(value) {
  const normalizedValue = String(value ?? '').trim();
  if (!normalizedValue) {
    return null;
  }

  const parsedValue = Number.parseFloat(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : null;
}

export function getMissingMemberFields(formData) {
  return REQUIRED_MEMBER_FIELDS.filter(({ key }) => !String(formData[key] ?? '').trim())
    .map(({ label }) => label);
}

export function buildMissingFieldsMessage(missingFields) {
  return `Please fill required fields: ${missingFields.join(', ')}`;
}

export function buildMemberPayload(formData, image, showMeasurements) {
  return {
    Name: formData.name.trim(),
    Address: formData.address.trim(),
    Mobile: parseInteger(formData.mobile),
    Occupation: formData.occupation.trim(),
    Age: parseInteger(formData.age),
    Duedate: formData.duedate,
    Startdate: formData.startdate,
    PendingFees: formData.feesStatus === 'pending' ? parseInteger(formData.pendingFees) ?? 0 : 0,
    FeesStatus: formData.feesStatus,
    Image: image || '',
    ...(showMeasurements && {
      Weight: parseDecimal(formData.weight),
      Chest: parseDecimal(formData.chest),
      Stomach: parseDecimal(formData.stomach),
      LowerTier: parseDecimal(formData.lowerTier),
      Waist: parseDecimal(formData.waist),
      Arm: parseDecimal(formData.arm),
      Hip: parseDecimal(formData.hip),
      Thigh: parseDecimal(formData.thigh),
    })
  };
}